import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRecommendationsDropdownData, getRecommendationsTableData, getSavedEvaluationFormData, saveEvaluationData, updateTrainingAssignmentDataStart, updateTrainingCommentsDataStart } from "../../../actions/Applications/aquaa.action";
import { AssignedAccountsTblPopUp } from "../../../components/TeamLeaderView/AgentsKPIModels/AgentsKPIModels";
import { getUserData } from "../../../actions/user.action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Edit_Icon from './../../../assets/onboard-images/Edit_Icon.png';
import Filter_Icon from './../../../assets/images/Filter_Icon.png';
import { OnboardSelect } from "../../../components/Onboard/OnboardComponents/Dropdown/Select";
import AdminBreadcrumb from "../../../components/Administration/General/Admin-breadcrumb";
import RefreshIcon from './../../../assets/images/Reset_Icon.png';



const Recommendations = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const recommendationsTableData = useSelector((state) => state.aquaaReducer.recommendationsTableData);
    const savedevaluationFormData = useSelector((state) => state.aquaaReducer.savedevaluationFormData);
    const recommendationsDropdownData = useSelector((state) => state.aquaaReducer.recommendationsDropdownData);
    console.log('recommendationsDropdownData', recommendationsDropdownData)
    let userInfo = useSelector((state) => state.userReducer.userInfo);



    const recommendationsOptions =
        recommendationsDropdownData?.[0]?.Recommendations || [];

    const evaluationStatusOptions =
        recommendationsDropdownData?.[0]?.EvaluationStatus || [];


    const [assignToMeModel, setAssignToMeModel] = useState(false);
    const [completeModel, setCompleteModel] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedComment, setSelectedComment] = useState('');
    const [isEvaluationFetched, setIsEvaluationFetched] = useState(false);
    const [selectedEvaluationID, setSelectedEvaluationID] = useState(null);
    const [isRefreshClicked, setIsRefreshedClicked] = useState(false);
    const [formData, setFormData] = useState({
        Recommendation: null,
        Status: null,
        InitialSave: false
    }); const [toggleValue, setToggleValue] = useState(false);
    const [error, setError] = useState(false)


    console.log('formData', formData)

    useEffect(() => {
        dispatch(getUserData());
        dispatch(getRecommendationsDropdownData())
    }, [dispatch])

    const tableData =
        recommendationsTableData?.[0]?.Training || [];
    const headers = tableData.length > 0
        ? Object.keys(tableData[0])
        : [];
    const handleEvaluationClick = (row) => {
        if (row.EvaluationsID && !isEvaluationFetched) {
            dispatch(getSavedEvaluationFormData(row.EvaluationsID));
            setIsEvaluationFetched(true);
            setSelectedEvaluationID(row.EvaluationsID);
        }
    };

    useEffect(() => {
        if (
            savedevaluationFormData &&
            Array.isArray(savedevaluationFormData) &&
            savedevaluationFormData.length > 0 &&
            isEvaluationFetched &&
            selectedEvaluationID ===
            savedevaluationFormData?.[0]?.AccountDetails?.[0]?.EvaluationID
        ) {
            dispatch(saveEvaluationData(savedevaluationFormData));

            setIsEvaluationFetched(false);

            history.push("/evaluationform");
        }
    }, [
        savedevaluationFormData,
        dispatch,
        history,
        isEvaluationFetched,
        selectedEvaluationID
    ]);
    const handleAssignToMe = () => {
        if (!selectedRow) return;
        console.log("Assign to me clicked for:", selectedRow);

        const dispobj = [
            {
                "EvaluationsID": selectedRow.EvaluationsID,
                "Agent": selectedRow.AgentEmail,
                "Recommendation": selectedRow.Recommendation
            }]
        dispatch(updateTrainingAssignmentDataStart(dispobj, () => {
            dispatch(getRecommendationsTableData(formData?.Recommendation?.Recommendation || "",
                formData?.Status?.Ord || "",
                formData?.InitialSave ? 1 : 0));
        }))

        setAssignToMeModel(false)
    };

    const submitHandler = () => {
        if (!selectedRow) return;
        if (!selectedComment) {
            setError(true)
        }
        else {
            dispatch(updateTrainingCommentsDataStart([{
                EvaluationsID: selectedRow.EvaluationsID,
                ActionComments: selectedComment,
                Recommendation: selectedRow.Recommendation,
                Agent: selectedRow.AgentEmail
            }]
                , () => {
                    dispatch(getRecommendationsTableData(formData?.Recommendation?.Recommendation || "",
                        formData?.Status?.Ord || "",
                        formData?.InitialSave ? 1 : 0));
                }));
            setCompleteModel(false)
            setSelectedComment('')
        }

    }

    const addValueToFormData = (name, selectedOption) => {
        if (name !== 'Select') {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: selectedOption,
            }));
        }
    };

    const onChangeGeneraltoggle = (e) => {
        const checked = e.target.checked;

        setToggleValue(checked);

        setFormData((prev) => ({
            ...prev,
            InitialSave: checked
        }));
    };

    useEffect(() => {
        dispatch(
            getRecommendationsTableData(
                formData?.Recommendation?.Recommendation || "",
                formData?.Status?.Ord || "",
                formData?.InitialSave ? 1 : 0
            )
        );
    }, [formData, dispatch]);

    const handleReset = () => {
        setFormData({
            Recommendation: null,
            Status: null,
            InitialSave: false
        });

        setToggleValue(false);
        setIsRefreshedClicked(true); // this will reset dropdown UI (your OnboardSelect uses this)
    };


    return (
        <div >
            <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={false} label3='Recommendations' />

            <section className='App_Layout'><div className='Applications_Title'> Recommendations </div></section>

            <section className='Filter_aquaa'>
                <main className='aquaa_filter_img'>
                    <img src={Filter_Icon} alt='' style={{ padding: '20px', paddingTop: '30px', paddingLeft: '30px' }} />
                </main>
                <div className='aquaaFilterAlignment'>

                    <main className='Aquaa_dropdown' style={{ width: 300 }}>
                        <label HtmlFor='username'>Recommendations</label>
                        <OnboardSelect data={recommendationsOptions} name='Recommendation' value='Recommendation' id='Id' marginTop='10px'
                            editValue='' addValueToQueue={(key, value) => {
                                addValueToFormData(key, value);
                                setIsRefreshedClicked(false);
                            }} refresh={isRefreshClicked} passFullObject={true} />
                    </main>
                    <main className='Aquaa_dropdown' style={{ width: 300 }}>
                        <label HtmlFor='country'>Status</label>
                        <OnboardSelect data={evaluationStatusOptions} name='Status' value='Status' id='Id' marginTop='10px'
                            editValue='' addValueToQueue={(key, value) => {
                                addValueToFormData(key, value);
                                setIsRefreshedClicked(false);
                            }} refresh={isRefreshClicked} passFullObject={true} />
                    </main>

                    <div>
                        <div className='site' style={{ marginLeft: '20px' }}>Assigned to me</div>
                        <div style={{ display: 'flex' }}> <span >
                            <label class="toggle" style={{ marginLeft: '30%' }}>
                                <input type="checkbox"
                                    name='accountToggle'
                                    checked={toggleValue}
                                    onChange={onChangeGeneraltoggle}
                                />
                                <div class="slider_on"></div>
                                <span class="labels" data-on="YES" data-off="NO"></span>
                            </label>
                        </span>
                        </div>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <img src={RefreshIcon} alt='' onClick={() => handleReset()} width='30px' height='30px' />
                    </div>

                    {/* <button className='btn_adduser' onClick={() => {
            dispatch(getAquaaAWSData(selectedAccount.accountID, selectedRole, selectedChannel.channel, selectedLanguage, selectedLocation.location, selectedDate.From, selectedDate.To));
            setLoadCliked(true)
          }}>LOAD</button> */}
                </div>
            </section>
            <div className="aquaa-table-container" style={{ marginTop: '20px' }}>
                <table className="aquaa-table">

                    <thead>
                        <tr>
                            {headers.map((header, index) => (
                                <th key={index}>{header}</th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {tableData && tableData.length > 0 ? (
                            tableData.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {headers.map((header, colIndex) => {

                                        const value = row[header];

                                        return (
                                            <td key={colIndex}>

                                                {/* Evaluation ID clickable */}
                                                {header === "EvaluationsID" ? (
                                                    <span
                                                        style={{ color: "blue", cursor: "pointer" }}
                                                        onClick={() => handleEvaluationClick(row)}
                                                    >
                                                        {value}
                                                    </span>
                                                )

                                                    /* Assign to me link */
                                                    : header === "Assigned To" && value === null ? (
                                                        <span
                                                            style={{ color: "#1976d2", cursor: "pointer", fontWeight: "600" }}
                                                            onClick={() => {
                                                                setSelectedRow(row);
                                                                setAssignToMeModel(true);
                                                            }}
                                                        >
                                                            Assign to Me
                                                        </span>
                                                    )
                                                        : header === "Status" ? (
                                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                <span>{value}</span>

                                                                {value === "In Progress" &&
                                                                    row["Assigned To"] &&
                                                                    userInfo?.email === row["Assigned To"] && (

                                                                        <img src={Edit_Icon} alt='' onClick={() => {
                                                                            setSelectedRow(row);
                                                                            setCompleteModel(true);
                                                                        }} />

                                                                    )}
                                                            </div>
                                                        )

                                                            /* Date formatting */
                                                            : header === "Action Due Date" ? (
                                                                new Date(value).toLocaleDateString()
                                                            )

                                                                /* Default rendering */
                                                                : (
                                                                    value || "-"
                                                                )

                                                }

                                            </td>
                                        );
                                    })}
                                </tr>
                            ))) : (
                            <tr>
                                <td colSpan={headers.length || 1} style={{ textAlign: "center", padding: "20px" }}>
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table></div>

            {assignToMeModel && (
                <AssignedAccountsTblPopUp isOpen={assignToMeModel} setShowModal={setAssignToMeModel}>
                    <div className='Applications_Title' style={{ fontSize: '20px', marginBottom: 20 }}>Confirm Assignment</div>
                    <div>Are you sure you want to assign this recommendation to yourself?</div>
                    <main style={{ display: 'flex', justifyContent: 'center' }}>   <div className='btn_adduser' onClick={() => handleAssignToMe()}>Assign</div>
                        <div className='btn_canceluser' onClick={() => setAssignToMeModel(false)}>Cancel</div></main>
                </AssignedAccountsTblPopUp>
            )}

            {completeModel && (
                <AssignedAccountsTblPopUp isOpen={completeModel} setShowModal={setCompleteModel}>
                    <div className='Applications_Title' style={{ fontSize: '20px', marginBottom: 20 }}>Comments</div>
                    {error && <div style={{ color: 'red', marginTop: '5px', fontSize: '12px' }}>Comments are required</div>}
                    <div >
                        <textarea
                            type="text"
                            placeholder="Comments"
                            value={selectedComment}
                            onChange={(e) => setSelectedComment(e.target.value)}
                            style={{
                                width: '100%',
                                height: '100px',
                                padding: '10px',
                                fontSize: '14px',
                                resize: 'vertical',
                                borderRadius: '5px',
                                border: '1px solid #ccc',
                                boxSizing: 'border-box'
                            }}
                        />
                    </div>
                    <main style={{ display: 'flex', justifyContent: 'center' }}>   <div className='btn_adduser' onClick={() => submitHandler()}>Submit</div>
                        <div className='btn_canceluser' onClick={() => { setCompleteModel(false); setError(false); setSelectedComment('') }}>Cancel</div></main>
                </AssignedAccountsTblPopUp>
            )}
        </div>


    );
};

export default Recommendations;



